import * as ActionTypes from './types.action';

export function setCheckoutDataSuccess(checkoutData) {
  return {
    type: ActionTypes.SET_CHECKOUTDATA_SUCCESS,
    checkoutData
  };
}

export const setCheckoutData = checkoutData => dispatch => {
  dispatch(setCheckoutDataSuccess(checkoutData));
};



// WEBPACK FOOTER //
// ./actions/checkoutData.action.js